/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EsercenteRegistrationForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TerminiVersioneDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface RegistraEsercenteRequestParams {
    esercenteRegistrationForm: EsercenteRegistrationForm;
    xRecaptchaToken?: string;
}


export interface EsercenteRegistrazioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Versione corrente dei termini e privacy (esercente, pubblico).
     * Endpoint pubblico senza reCAPTCHA: serve al client per conoscere, prima della registrazione, la versione da dichiarare nel form e se la raccolta e\&#39; attiva.
     * @endpoint get /api/v1/esercente/registrazione/termini
*/
    getTerminiRegistrazioneEsercente(extraHttpRequestParams?: any): Observable<TerminiVersioneDTO>;

    /**
     * Registra un nuovo esercente titolare (self-service).
     * Endpoint pubblico protetto da reCAPTCHA. Crea un utente Keycloak disabilitato con ruolo ROLE_esercente, lo User locale (accountActivated&#x3D;false) e il ProfiloEsercente con i dati impresa, quindi invia la mail di attivazione. L\&#39;account resta inerte finché l\&#39;email non è verificata (PUT /api/v1/account/verification).
     * @endpoint post /api/v1/esercente/registrazione
* @param requestParameters
     */
    registraEsercente(requestParameters: RegistraEsercenteRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

}
